module.exports = __webpack_public_path__ + "img/sushi.f3bd538c.png";